"use strict";

const $ = require("jquery");

module.exports = function initializeMenuOutsideClick() {
    $(document).on("click", function (event) {
        const menu = $(".main-menu.in");
        if (menu.length && menu.css("position") === "fixed"
            && !$(event.target).closest(".main-menu, .navbar-toggler").length) {
            menu.find(".navbar>.close-menu>.close-button").first().trigger("click");
        }
    });
};
